import Vue from "vue";
import VueRouter from "vue-router";
// import ProductosComponent from "@/components/Inventario/ProductosComponent";
import AgregarProducto from "@/components/Inventario/AgregarProducto";
import EditarProducto from "@/components/Inventario/EditarProducto";
import MarcasCategorias from "@/components/MarcasCategorias/MarcasCategorias";
import RealizarVenta from "@/components/Ventas/RealizarVenta";
import ReporteVentas from "@/components/Ventas/ReporteVentas";
import ReporteCuentas from "@/components/Ventas/ReporteCuentas";
import ReporteApartados from "@/components/Ventas/ReporteApartados";
import ReporteCotizaciones from "@/components/Ventas/ReporteCotizaciones";
import ClientesComponent from "@/components/Clientes/ClientesComponent";
import AgregarCliente from "@/components/Clientes/AgregarCliente";
import EditarCliente from "@/components/Clientes/EditarCliente";
import UsuariosComponent from "@/components/Usuarios/UsuariosComponent";
import AgregarUsuario from "@/components/Usuarios/AgregarUsuario";
import EditarUsuario from "@/components/Usuarios/EditarUsuario";
import ConfiguracionComponent from "@/components/Configuracion/ConfiguracionComponent";
import PerfilComponent from "@/components/Usuarios/PerfilComponent";
import CambiarPassword from "@/components/Usuarios/CambiarPassword";
import ReporteCajeros from "@/components/Ventas/ReporteCajeros";
import HistorialMovimientos from "@/components/Inventario/HistorialMovimientos";
import PrecioExistencia from "@/components/Inventario/PrecioExistencia.vue";
import ReporteVentasUsuario from "@/components/Ventas/ReporteVentasUsuario.vue";
import IngresosEgresos from "@/components/Reportes/IngresosEgresos";
import NominaEmpleados from "@/components/Reportes/NominaEmpleados";
import FormularioNomina from "@/components/Reportes/FormularioNomina";
import FormularioNominaEditar from "@/components/Reportes/FormularioNominaEditar";
import GastosPagos from "@/components/Reportes/GastosPagos.vue";
import FormularioGastosPagos from "@/components/Reportes/FormularioGastosPagos.vue";
import FormularioGastosPagosEditar from "@/components/Reportes/FormularioGastosPagosEditar.vue";
import DatosProveedores from "@/components/Reportes/DatosProveedores.vue";
import FormularioProveedores from "@/components/Reportes/FormularioProveedores.vue";
import FormularioProveedoresEditar from "@/components/Reportes/FormularioProveedoresEditar.vue";
import ReportesGenerales from "@/components/Reportes/ReportesGenerales";
import FormularioAliado from "@/components/Reportes/FormularioAliado.vue";
import FormularioAliadoEditar from "@/components/Reportes/FormularioAliadoEditar.vue";
import DatosAliados from "@/components/Reportes/DatosAliados.vue";
import InformeVentas from "@/components/Reportes/InformeVentas.vue";
import GraficosVentasCiudad from "@/components/Reportes/GraficosVentasCiudad.vue";
import GraficosVendidos from "@/components/Reportes/GraficosVendidos.vue";
import ModuloRapido from "@/components/Inventario/ModuloRapido.vue";
import ReporteProductos from "@/components/Ventas/ReporteProductos.vue";
import CantidadesInventario from "@/components/Inventario/CantidadesInventario.vue";
import DashboardComponent from "@/components/Mensajes/DashboardComponent.vue";
/////////////////////
import Dashboard from "@/components/Dashboard.vue";
import Sorteos from "@/components/Sorteos/Sorteos.vue";
import InicioUsuario from "@/components/InicioUsuario.vue";
import EventosComponent from "@/components/Eventos/EventosComponent.vue";
import RestaurantesComponent from "@/components/Restaurantes/RestaurantesComponent.vue";
import ProductosComponent from "@/components/Productos/ProductosComponent.vue";
import InfoProducto from "@/components/Productos/InfoProducto.vue";
import LoginPrincipal from "@/components/Login/LoginPrincipal.vue";
import InfoRestaurante from "@/components/InfoRestaurante.vue";
import ParticipantesComponent from "@/components/Participantes/ParticipantesComponent.vue";
import EstadisticasComponent from "@/components/Estadisticas/EstadisticasComponent.vue";
import GraficosEstadisticas from "@/components/Estadisticas/GraficosEstadisticas.vue";
import ReglasEvento from "@/components/ReglasEvento.vue";
import JugadoresComponente from "@/components/JuegoGato/JugadoresComponente.vue";
///////////////////////////////////////////////////////
import Swal from "sweetalert2";

Vue.use(VueRouter);

function validarRol(to, from, next) {
  const rol = localStorage.getItem("rol");

  switch (rol) {
    case "administrador":
      next();
      break;

    case "inven":
      if (
        to.name === "AgregarProducto" ||
        to.name === "EditarProducto" ||
        to.name === "MarcasCategorias" ||
        to.name === "ReporteCajeros"
      ) {
        next();
      } else {
        next({ name: "Perfil" });
      }
      break;

    case "cajero":
      if (
        to.name === "RealizarVenta" ||
        to.name === "ClientesComponent" ||
        to.name === "AgregarCliente" ||
        to.name === "EditarCliente" ||
        to.name === "ReporteCajeros"
      ) {
        next();
      } else {
        next({ name: "Perfil" });
      }
      break;

    default:
      next({ name: "Perfil" });
      break;
  }
}
const routes = [
  {
    path: "/inicio",
    name: "InicioUsuario",
    component: InicioUsuario,
  },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/eventos", name: "EventosComponent", component: EventosComponent },
  { path: "/ReglasEvento", name: "ReglasEvento", component: ReglasEvento },
  {
    path: "/jugadores",
    name: "JugadoresComponente",
    component: JugadoresComponente,
  },
  {
    path: "/restaurantes",
    name: "RestaurantesComponent",
    component: RestaurantesComponent,
  },
  {
    path: "/productos",
    name: "ProductosComponent",
    component: ProductosComponent,
  },
  {
    path: "/participantes",
    name: "ParticipantesComponent",
    component: ParticipantesComponent,
  },
  {
    path: "/estadisticas",
    name: "EstadisticasComponent",
    component: EstadisticasComponent,
  },
  {
    path: "/graficos",
    name: "GraficosEstadisticas",
    component: GraficosEstadisticas,
  },
  {
    path: "/sorteos",
    name: "Sorteos",
    component: Sorteos,
  },
  {
    path: "/restaurante/:id",
    name: "InfoRestaurante",
    component: InfoRestaurante,
  },
  { path: "/producto/:id", name: "InfoProducto", component: InfoProducto },
  { path: "/login", name: "LoginPrincipal", component: LoginPrincipal },
  { path: "/", redirect: "/inicio" },

  {
    path: "/Dashboarsd",
    name: "DashboardComponent",
    component: DashboardComponent,
    beforeEnter: validarRol,
  },
  {
    path: "/agregar-producto",
    name: "AgregarProducto",
    component: AgregarProducto,
    beforeEnter: validarRol,
  },
  {
    path: "/editar-producto/:id",
    name: "EditarProducto",
    component: EditarProducto,
    beforeEnter: validarRol,
  },
  {
    path: "/marcas-y-categorias",
    name: "MarcasCategorias",
    component: MarcasCategorias,
    beforeEnter: validarRol,
  },
  {
    path: "/realizar-venta",
    name: "RealizarVenta",
    component: RealizarVenta,
    beforeEnter: validarRol,
  },
  {
    path: "/reporte-ventas",
    name: "ReporteVentas",
    component: ReporteVentas,
    beforeEnter: validarRol,
  },
  {
    path: "/reporte-ventas-usuario",
    name: "ReporteVentasUsuario",
    component: ReporteVentasUsuario,
    beforeEnter: validarRol,
  },
  {
    path: "/reporte-cuentas",
    name: "ReporteCuentas",
    component: ReporteCuentas,
    beforeEnter: validarRol,
  },
  {
    path: "/reporte-apartados",
    name: "ReporteApartados",
    component: ReporteApartados,
    beforeEnter: validarRol,
  },
  {
    path: "/reporte-cotizaciones",
    name: "ReporteCotizaciones",
    component: ReporteCotizaciones,
    beforeEnter: validarRol,
  },
  {
    path: "/clientes",
    name: "ClientesComponent",
    component: ClientesComponent,
    beforeEnter: validarRol,
  },
  {
    path: "/agregar-cliente",
    name: "AgregarCliente",
    component: AgregarCliente,
    beforeEnter: validarRol,
  },
  {
    path: "/editar-cliente/:id",
    name: "EditarCliente",
    component: EditarCliente,
    beforeEnter: validarRol,
  },
  {
    path: "/usuarios",
    name: "UsuariosComponent",
    component: UsuariosComponent,
    beforeEnter: validarRol,
  },
  {
    path: "/agregar-usuario",
    name: "AgregarUsuario",
    component: AgregarUsuario,
    beforeEnter: validarRol,
  },
  {
    path: "/editar-usuario/:id",
    name: "EditarUsuario",
    component: EditarUsuario,
    beforeEnter: validarRol,
  },
  {
    path: "/configurar",
    name: "ConfiguracionComponent",
    component: ConfiguracionComponent,
    beforeEnter: validarRol,
  },
  {
    path: "/reporte-cajeros",
    name: "ReporteCajeros",
    component: ReporteCajeros,
    beforeEnter: validarRol,
  },
  {
    path: "/historial-movimientos",
    name: "HistorialMovimientos",
    component: HistorialMovimientos,
    beforeEnter: validarRol,
  },

  {
    path: "/perfil",
    name: "PerfilComponent",
    component: PerfilComponent,
    beforeEnter: (to, from, next) => {
      Swal.fire({
        title: "Acceso restringido",
        input: "password",
        inputPlaceholder: "Ingrese la contraseña",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        inputAttributes: {
          autocapitalize: "off",
        },
        preConfirm: (password) => {
          if (password === "1819") {
            return true;
          } else {
            Swal.showValidationMessage("Contraseña incorrecta");
            return false;
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          next();
        } else {
          next(false); // Bloquear acceso si no se confirma
        }
      });
    },
  },

  {
    path: "/cambiar-password",
    name: "CambiarPassword",
    component: CambiarPassword,
    beforeEnter: validarRol,
  },
  {
    path: "/precio-existencia",
    name: "PrecioExistencia",
    component: PrecioExistencia,
  },

  {
    path: "/ingresos-egresos",
    name: "IngresosEgresos",
    component: IngresosEgresos,
    beforeEnter: validarRol,
  },

  {
    path: "/nomina-empleados",
    name: "NominaEmpleados",
    component: NominaEmpleados,
    beforeEnter: validarRol,
  },

  {
    path: "/formulario-nomina",
    name: "FormularioNomina",
    component: FormularioNomina,
    beforeEnter: validarRol,
  },

  {
    path: "/formulario-nomina-editar",
    name: "FormularioNominaEditar",
    component: FormularioNominaEditar,
    beforeEnter: validarRol,
  },

  {
    path: "/gastos-pagos",
    name: "GastosPagos",
    component: GastosPagos,
    beforeEnter: validarRol,
  },

  {
    path: "/formulario-gastos-pagos",
    name: "FormularioGastosPagos",
    component: FormularioGastosPagos,
    beforeEnter: validarRol,
  },

  {
    path: "/formulario-gastos-pagos-editar",
    name: "FormularioGastosPagosEditar",
    component: FormularioGastosPagosEditar,
    beforeEnter: validarRol,
  },

  {
    path: "/formulario-proveedores",
    name: "FormularioProveedores",
    component: FormularioProveedores,
    beforeEnter: validarRol,
  },
  {
    path: "/datos-proveedores",
    name: "DatosProveedores",
    component: DatosProveedores,
    beforeEnter: validarRol,
  },
  {
    path: "/formulario-proveedores-editar",
    name: "FormularioProveedoresEditar",
    component: FormularioProveedoresEditar,
    beforeEnter: validarRol,
  },
  {
    path: "/reportes-generales",
    name: "ReportesGenerales",
    component: ReportesGenerales,
    beforeEnter: validarRol,
  },
  {
    path: "/formulario-aliado",
    name: "FormularioAliado",
    component: FormularioAliado,
    beforeEnter: validarRol,
  },
  {
    path: "/formulario-aliado-editar",
    name: "FormularioAliadoEditar",
    component: FormularioAliadoEditar,
    beforeEnter: validarRol,
  },
  {
    path: "/datos-aliados",
    name: "DatosAliados",
    component: DatosAliados,
    beforeEnter: validarRol,
  },
  {
    path: "/informe-ventas",
    name: "InformeVentas",
    component: InformeVentas,
    beforeEnter: validarRol,
  },
  {
    path: "/graficos-ventas-ciudad",
    name: "GraficosVentasCiudad",
    component: GraficosVentasCiudad,
    beforeEnter: validarRol,
  },
  {
    path: "/graficos-vendidos",
    name: "GraficosVendidos",
    component: GraficosVendidos,
    beforeEnter: validarRol,
  },
  {
    path: "/modulo-rapido",
    name: "ModuloRapido",
    component: ModuloRapido,
    beforeEnter: validarRol,
  },
  {
    path: "/ReporteProductos",
    name: "ReporteProductos",
    component: ReporteProductos,
    beforeEnter: validarRol,
  },
  {
    path: "/CantidadesInventario",
    name: "CantidadesInventario",
    component: CantidadesInventario,
    beforeEnter: validarRol,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  next();
});

router.afterEach(() => {
  document.title = "Metropolitan Food";
});

export default router;
